// Aura animates the spinner ring through four separate colour tokens
// (p-progressspinner-color, 6s cycle). With our palette those resolve to
// red, MoBlue, green and Aura's fallback yellow — so the indicator would
// blink error-red and success-green while loading, which is semantically
// wrong. Collapsing all four onto the primary colour keeps the keyframe
// running but makes it invisible, leaving a single-colour brand ring.
export const progressspinnerTheme = {
  colorScheme: {
    light: {
      root: {
        colorOne: '{primary.500}',
        colorTwo: '{primary.500}',
        colorThree: '{primary.500}',
        colorFour: '{primary.500}'
      }
    },
    dark: {
      root: {
        colorOne: '{primary.400}',
        colorTwo: '{primary.400}',
        colorThree: '{primary.400}',
        colorFour: '{primary.400}'
      }
    }
  }
};
